
import { defineComponent } from "vue";

export default defineComponent({
  name: "dropdown-5",
  components: {},
});
